module.exports = __webpack_public_path__ + "img/error-ico.d2c9a3b9.svg";